export class DtoHasApi {
    static url: string;

    static get apiUrl(): string {
        return this.url;
    }

    constructor() {}
}
